// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .blissey .stars-rating {\n        display: flex;\n        color: #f6a627;\n        gap: 2px;\n    }", ""]);
// Exports
module.exports = exports;
